import { Anchor, Badge, Group, Stack, Text, Title } from '@mantine/core';
import { ArrowLeft, Check, CloudOff, Loader } from 'react-feather';
import { Link } from 'react-router-dom';
import type { SaveState } from '../hooks/useMatchingDraft';

interface MatchingHeaderProps {
  cohortId: string;
  cohortName: string;
  /** e.g. "GS26 · Goldman Sachs · 48 participants" */
  meta: string;
  statusLabel?: string;
  statusColor?: string;
  requestName?: string;
  saveState?: SaveState;
}

const SAVE_LABELS: Record<SaveState, { label: string; icon: typeof Check }> = {
  saved: { label: 'Saved', icon: Check },
  saving: { label: 'Saving…', icon: Loader },
  offline: { label: 'Not saved — reconnecting', icon: CloudOff },
};

export function MatchingHeader({
  cohortId,
  cohortName,
  meta,
  statusLabel,
  statusColor = 'blue',
  requestName,
  saveState,
}: MatchingHeaderProps) {
  const save = saveState ? SAVE_LABELS[saveState] : null;
  return (
    <Stack gap="xs" mb="lg">
      <Anchor
        component={Link}
        to={`/cohorts/${cohortId}`}
        size="sm"
        w="fit-content"
      >
        <Group gap={6} wrap="nowrap">
          <ArrowLeft size={16} />
          {cohortName}
        </Group>
      </Anchor>
      <Group justify="space-between" align="flex-end">
        <Stack gap={6}>
          <Title order={1}>Matching</Title>
          <Group gap="sm">
            <Text c="dimmed">{meta}</Text>
            {statusLabel && (
              <Badge color={statusColor} variant="light">
                {statusLabel}
              </Badge>
            )}
            {requestName && (
              <Badge color="gray" variant="light">
                {requestName}
              </Badge>
            )}
          </Group>
        </Stack>
        {save && (
          <Group
            gap={6}
            c={saveState === 'offline' ? 'dangerRed.7' : 'dimmed'}
            aria-live="polite"
          >
            <save.icon size={14} />
            <Text size="sm">{save.label}</Text>
          </Group>
        )}
      </Group>
    </Stack>
  );
}
